<template>
  <form class="bt-form">
    <div class="form-grid">
      <div class="form-group">
        <label for="cardNumber">Card Number</label>
        <div id="cardNumber" class="form-control bt-input"></div>
      </div>
      <div class="form-group">
        <label for="cardExpirationDate">Expiration Date</label>
        <div id="cardExpirationDate" class="form-control bt-input"></div>
      </div>
      <div class="form-group">
        <label for="cardVerificationCode">CVC</label>
        <div id="cardVerificationCode" class="form-control bt-input"></div>
      </div>
    </div>
    <transition name="bt-fade">
      <div
        id="card-number-error"
        v-if="cardNumberError"
        class="bt-error"
        role="alert"
        aria-live="polite"
      >
        <div class="bt-error-inner">
          <svg class="bt-error-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path d="M12 9v4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <circle cx="12" cy="17" r="1" fill="currentColor"/>
            <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1" opacity="0.8"/>
          </svg>
          <div class="bt-error-message">{{ cardNumberError }}</div>
          <button
            type="button"
            class="bt-error-close"
            @click="cardNumberError = ''"
            aria-label="Dismiss error"
          >&times;</button>
        </div>
      </div>
    </transition>
    <div class="form-grid">
      <div class="form-group">
        <label for="firstName">First Name</label>
        <input id="firstName" class="form-control bt-input" v-model="firstName" placeholder="First Name"/>
      </div>
      <div class="form-group">
        <label for="lastName">Last Name</label>
        <input id="lastName" class="form-control bt-input" v-model="lastName" placeholder="Last Name" required/>
      </div>
      <div class="form-group">
        <label for="lastName">Zip Code</label>
        <input id="zipCode" type="numeric" pattern="^\d{5}(-\d{4})?$" class="form-control bt-input" v-model="zipCode" placeholder="Zip Code" required/>
      </div>
    </div>
  </form>
</template>

<script>
import { basistheory } from "@basis-theory/web-elements";

export default {
  name: "BasisTheoryForm",
  data() {
    return {
      bt: null,
      cardNumberElement: null,
      cardExpirationDateElement: null,
      cardVerificationCodeElement: null,
      firstName: "",
      lastName: "",
      cardNumberError: "",
      zipCode: "",
    };
  },
  mounted() {
    basistheory(this.$config("services.basis_theory_public_token")).then((bt) => {
      this.bt = bt;
      this.setupElements();
    }).catch((e) => {
        this.$fnNotify({message: "An error occurred starting up this page, please try again later or contact support.", type:"error"});
        console.error("Basis Theory public key is not configured");
        return;
    })
  },
  updated() {
    console.log(`[Render Completed at] ${new Date().toLocaleTimeString()}`);
  },
  methods: {
    setupElements() {
      this.$emit("set-loading", true);
      this.cardNumberElement = this.bt.createElement("cardNumber", {
        targetId: "basis-theory-card-number"
      });
      this.cardExpirationDateElement = this.bt.createElement("cardExpirationDate", {
        targetId: "basis-theory-card-expiration-date"
      });
      this.cardVerificationCodeElement = this.bt.createElement("cardVerificationCode", {
        targetId: "basis-theory-card-verification-code"
      });

      Promise.all([
        this.cardNumberElement.mount("#cardNumber"),
        this.cardExpirationDateElement.mount("#cardExpirationDate"),
        this.cardVerificationCodeElement.mount("#cardVerificationCode"),
      ]).then(() => {
        this.cardNumberElement.on("change", ({ cardBrand }) => {
          if (cardBrand === "american-express") {
            this.cardNumberError = "We currently do not accept American Express cards.";
          } else {
            this.cardNumberError = "";
          }
          this.cardVerificationCodeElement.update({ cardBrand });
        });
        this.$emit("set-loading", false);
      });
    },
    submitCard() {
      this.$emit("set-loading", true);
      try {

        this.bt.tokenIntents.create({
          type: "card",
          data: {
            number: this.cardNumberElement,
            expiration_month: this.cardExpirationDateElement.month(),
            expiration_year: this.cardExpirationDateElement.year(),
            cvc: this.cardVerificationCodeElement,
          }
        }).then((token) => {
          this.$emit("token-created", token);
          this.$emit("set-loading", true);
        })
        .catch((error) => {
          if (error.name = "BasisTheoryValidationError") {
            this.$fnNotify({message: "One or more values you entered are invalid: date, card number or CVV. Please check and try again.", type:"error"});
          } else if (error.name = "BasisTheoryApiError") {
            this.$fnNotify({message: "An error occurred while processing your card. Please try again later.", type:"error"});
          }
          this.$emit("set-loading", false);
        });

      }
      catch (err) {
        this.$emit("token-error", err);
        this.$emit("set-loading", false);
      }
    },
  },
};
</script>

<style scoped>
.bt-form {
  max-width: 700px;
  margin: 0 auto;
}
.form-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 20px;
}
.form-group {
  display: flex;
  flex-direction: column;
  flex: 1 1 180px;
  min-width: 160px;
  margin-bottom: 0;
}
@media (max-width: 600px) {
  .form-group {
    flex: 1 1 100%;
    min-width: unset;
  }
}
label {
  margin-bottom: 6px;
  font-weight: 500;
}
.bt-input {
  min-height: 40px;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 12px;
  background: #fff;
  font-size: 16px;
  box-sizing: border-box;
}
@media (max-width: 600px) {
  .form-grid {
    flex-direction: column;
    gap: 10px;
  }
  .form-group {
    min-width: 0;
  }
}

.bt-error {
  display: flex;
  justify-content: center;
  margin-bottom: 12px;
}
.bt-error-inner {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(224, 67, 67, 0.06);
  border: 1px solid rgba(224, 67, 67, 0.18);
  color: #b00020;
  padding: 10px 14px;
  border-radius: 10px;
  box-shadow: 0 6px 18px rgba(176, 0, 32, 0.04);
  width: 100%;
  max-width: 760px;
  box-sizing: border-box;
}
.bt-error-icon {
  flex: 0 0 20px;
  color: #b00020;
}
.bt-error-message {
  flex: 1;
  font-size: 14px;
  line-height: 1.2;
}
.bt-error-close {
  background: transparent;
  border: 0;
  color: inherit;
  font-size: 18px;
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  line-height: 1;
}
.bt-error-close:focus {
  outline: 2px solid rgba(176,0,32,0.18);
}

.bt-fade-enter-active, .bt-fade-leave-active {
  transition: opacity 220ms ease, transform 220ms ease;
}
.bt-fade-enter-from, .bt-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
</style>
